import { BasicCard } from '../../basicCard';
import { ContentContainer, HeaderWrapper } from '../styles';
import { Flex } from 'shared/ui/flex';
import { Typography } from 'shared/ui/typography';
import { FC } from 'react';
import { CardProps } from '../types';

export const Card: FC<CardProps> = ({
	children,
	headerContent,
	styles = {
		width: '595px',
		height: '565px',
    
		fontSize: 'h2',
		isBold: true,
		cardVariant: 'main',
		padding: '16px',
		headerHeight: '40px',
		header: { height: '40px', padding: '16px' },
	},
	indentsCard = true,
	buttons = [],
  headerRounded = false,
  onHeaderClick,
}) => {
	return (
		<BasicCard variant={styles?.cardVariant || 'main'}>
			<HeaderWrapper
        className='HeaderWrapper'
				$height={styles?.header?.height}
				$padding={styles?.header?.padding}
        $isRounded={headerRounded}
        onClick={onHeaderClick}
			>
				<Flex
					$justify="space-between"
					$alignItems="center"
					$width="100%"
				>
					<Typography
						mode={styles.fontSize}
						isBold={styles.isBold}
						colorVariant={'main'}
					>
						{headerContent}
					</Typography>
					<Flex $alignItems="center">
						{buttons.map(button => {
							return button;
						})}
					</Flex>
				</Flex>
			</HeaderWrapper>
			<ContentContainer $margins={indentsCard} $padding={styles.padding}>
				{children}
			</ContentContainer>
		</BasicCard>
	);
};
